import { ProductionPlanAnimalType } from "../../../../interfaces/enums";
import { 
    IPlanAnimalData,
    IPlannedAnimal,
    IProductionPlan,
    IProductionPlanSlaughterSales 
} from "../../../../interfaces/IProductionPlan";
import { PlannedAnimalMapperBase } from "./PlannedAnimalMapperBase";

class Mapper extends PlannedAnimalMapperBase {

    ToDataGrid(a: IPlannedAnimal[]): IProductionPlanSlaughterSales {
        return {
            Cows: a.find(x => x.Type === ProductionPlanAnimalType.BeefCow)?.Amount || 0,
            Bulls: a.find(x => x.Type === ProductionPlanAnimalType.BeefBull)?.Amount || 0,
            Heifers: a.find(x => x.Type === ProductionPlanAnimalType.BeefHeifer)?.Amount || 0,
            SlaughterBeefBull: a.find(x => x.Type === ProductionPlanAnimalType.SlaughterBeefBull)?.Amount || 0,
            SlaughterBeefHeifer: a.find(x => x.Type === ProductionPlanAnimalType.SlaughterBeefHeifer)?.Amount || 0,
        }
    }

    ToPlan(
        plan: IPlanAnimalData,
        collection: keyof IPlanAnimalData,
        x: IProductionPlanSlaughterSales
    ) {
        const a = plan[collection] as IPlannedAnimal[];
        this.MapToArrayByType(a, ProductionPlanAnimalType.BeefCow, x.Cows);
        this.MapToArrayByType(a, ProductionPlanAnimalType.BeefBull, x.Bulls);
        this.MapToArrayByType(a, ProductionPlanAnimalType.BeefHeifer, x.Heifers);
        this.MapToArrayByType(a, ProductionPlanAnimalType.SlaughterBeefBull, x.SlaughterBeefBull);
        this.MapToArrayByType(a, ProductionPlanAnimalType.SlaughterBeefHeifer, x.SlaughterBeefHeifer);
    }
}

export default new Mapper();